<div #filterElement class="scroll_div">
    <div class="filter_pills">
        <mat-chip-list class="filter_chip_list" #filterChipList>
            <div
                *ngFor="let filter of selectedFilters"
                [ngSwitch]="filter.filterType">
                <filter-single-select-search
                    class="flex"
                    [filter]="filter"
                    *ngSwitchCase="filterTypeEnum.SearchableSingleSelect">
                </filter-single-select-search>
                <filter-multi-select-search
                    class="flex"
                    [filter]="filter"
                    *ngSwitchCase="filterTypeEnum.SearchableMultiSelect">
                </filter-multi-select-search>
                <filter-single-select
                    class="flex"
                    [filter]="filter"
                    *ngSwitchCase="filterTypeEnum.SingleSelect">
                </filter-single-select>
                <filter-toggle
                    class="flex"
                    [filter]="filter"
                    *ngSwitchCase="filterTypeEnum.Toggle">
                </filter-toggle>
                <filter-multi-select
                    class="flex"
                    [filter]="filter"
                    *ngSwitchCase="filterTypeEnum.MultiSelect">
                </filter-multi-select>
                <filter-single-select-combination
                    class="flex"
                    [filter]="filter"
                    *ngSwitchCase="filterTypeEnum.CombinationSingleSelect">
                </filter-single-select-combination>
                <filter-single-select-date-range
                    class="flex"
                    [filter]="filter"
                    *ngSwitchCase="filterTypeEnum.SingleSelectDateRange">
                </filter-single-select-date-range>
            </div>
        </mat-chip-list>
    </div>
</div>
